export default "__VITE_ASSET__DkTQPv_u__"